module.exports = __webpack_public_path__ + "img/activity-log.da2a4808.png";